import React, { useEffect, useState, useContext,useCallback } from "react";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
import moment from "moment";
//Function
import { getReportRefill } from "../api";
import { ApiDateTimeFormat, ToMonthText } from "../../../utils/date";
//Material Ui
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import { BaseContainer } from "../../../stories/base-container";
import Criteria from "../criteria";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReportTable from "../table";
//Context
import {
  LoadingContext,
  withLoadingContext,
} from "../../../context/loading-context";
const columnsData = [
  {
    id: "BUSINESSDATE",
    label: "Date",
    minWidth: 170,
    align: "center",
    dataAlign: "center",
  },
  {
    id: "REFILL_T1",
    label: "T1",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
  {
    id: "REFILL_T3",
    label: "T3",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
  {
    id: "DIFF_T1T3",
    label: "Different",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
];
function Refill() {
  const methods = useForm({
    defaultValues: { date: moment().format(ApiDateTimeFormat) },
  });
  const Loading_context = useContext(LoadingContext);
  const { actions: load_actions } = Loading_context;
  const [Data_lst, setData_lst] = useState([]);
  const [date, setDate] = useState();
  const { getValues } = methods;
  const query = useCallback(async () => {
    let param = getValues();
    let dat = await load_actions.withLoading(() => getReportRefill(param));
    if (!dat) return;
    setData_lst(dat?.Data?.Rows);
    setDate(ToMonthText(dat?.Date));
  }, [load_actions, getValues]);
  useEffect(() => {
    query()
  }, [query]);
  //changeColor(columnsDom, "DIF", Dom_lst[0]?.DIFF_COLOR_CODE);
  return (
    <FormProvider {...methods}>
      <BaseContainer>
      {Loading_context.state?.isLoading ? (
          <div className="lineLoading">
            <LinearProgress />
          </div>
        ) : null}
        <Box display="flex" justifyContent="center">
          <Typography variant="h4"> refill report</Typography>
        </Box>
        <Criteria query={query} month/>
        <Box display="flex" justifyContent="center">{`Month :${
          date || ""
        }`}</Box>
        <ReportTable
          data={Data_lst}
          columns={columnsData}
          cellColor={[{ fieldId: "DTN_DIFF", fieldColor: "DIFF_COLOR_CODE" }]}
        />
      </BaseContainer>
    </FormProvider>
  );
}
export default withLoadingContext(Refill);
